/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import FileSystemType from '../file/system/file-system-type';
import focus from '../focus/focus-directive';
import SetupHeader from './setup-header';
import template from './setup-storage.html';

export default {
  name: 'SetupStorage',
  template,
  components: { SetupHeader },
  created() {
    this.submitted = false;
    this.getAllUnits();
    this.checkStorageInterval = window.setInterval(() => {
      this.getAllUnits();
    }, 5000);
    window.console.info('SetupStorage created');
  },
  destroyed() {
    window.clearInterval(this.checkStorageInterval);
  },
  directives: { focus },
  data() {
    return {
      field: {
        storage: {
          label: 'Storage',
          value: this.storage
        }
      },
      isExternalAvailable: false
    };
  },
  methods: {
    getAllUnits() {
      const { fileSystemManager } = this.$root;
      fileSystemManager.getAllUnits().then((fileSystemUnits) => {
        const externalFileSystemUnits = fileSystemUnits.filter(
          (fileSystemUnit) =>
            fileSystemUnit.getType() === FileSystemType.Usb ||
            fileSystemUnit.getType() === FileSystemType.SdCard
        );
        this.isExternalAvailable =
          externalFileSystemUnits && externalFileSystemUnits.length > 0;
      });
    },
    selectStorage(storage) {
      this.field.storage.value = storage;
    },
    handleError(error) {
      this.$root.logger.error(error);
    },
    onBack() {
      this.$emit('back');
    },
    onReset() {
      this.field.storage.value = this.defaultStorage;
    },
    onSubmit() {
      this.$emit('submit', this.field.storage.value);
    }
  },
  props: ['defaultStorage', 'isOnline', 'storage']
};
